import './index.scss';
import React from 'react';

class Checkbox extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChange = () => {
    const { props } = this;

    if (props.onChange) {
      props.onChange(props.value);
    }
  };

  render() {
    const { props } = this;
    const { disabled = false } = props;
    const onClick = !disabled ? this.handleChange : null;

    return (
      <div
        class={`checkboxItem ${props.checked ? 'active' : ''}`}
        onClick={onClick}
      >
        {props.checked && <i class="material-icons">check</i>}
      </div>
    );
  }
}

Checkbox.defaultProps = {
  checked: false,
};

export default Checkbox;
